/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgRaiseHand = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="#FFC72C"
      stroke="gold"
      d="M256.051.5c17.424 0 31.5 14.076 31.5 31.5v208c0 9.076 7.424 16.5 16.5 16.5s16.5-7.424 16.5-16.5V64c0-17.424 14.076-31.5 31.5-31.5s31.5 14.076 31.5 31.5v176c0 9.076 7.424 16.5 16.5 16.5s16.5-7.424 16.5-16.5V128c0-17.424 14.076-31.5 31.5-31.5s31.5 14.076 31.5 31.5v208c0 96.924-78.576 175.5-175.5 175.5h-19.2c-59.008 0-115.755-22.495-158.645-62.904l-1.011-.958-112.4-107c-15.802-15.112-16.49-40.095-1.383-55.893 15.11-15.8 40.094-16.393 55.894-1.384v.001l60.5 57.6.929.885-.086-1.281c-.098-1.48-.098-3.063-.098-4.566V64c0-17.424 14.076-31.5 31.5-31.5s31.5 14.076 31.5 31.5v176c0 9.076 7.424 16.5 16.5 16.5s16.5-7.424 16.5-16.5V32c0-17.424 14.076-31.5 31.5-31.5Z"
    />
  </svg>
)
export default SvgRaiseHand
